var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-content-container px-0 pa-md-0",class:{ 'app-content-container-boxed': _vm.appContentWidth === 'boxed' }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }